import React from 'react';
import CaseStudy from './CaseStudy';
import projects from '../data/projects';
import './CaseStudy.css';

const project = projects.find((p) => p.slug === 'amz-sp-api-pipeline');

const CategoryAnalysis = () => {
  const icons = [
    { src: '/images/python-logo-1.png', alt: 'Python' },
    { src: '/images/excel.png', alt: 'Excel' },
  ];

  const slots = {
    afterPipeline: (
      <section className="case-study-section case-study-card">
        <img
          src="/images/analysis.png"
          alt="Amazon Category Analysis visuals"
          className="case-study-image"
        />
        <p className="case-study-caption">
          Category and product-level views built from the curated dataset after cleaning and
          normalization.
        </p>
      </section>
    ),
  };

  return <CaseStudy project={project} icons={icons} slots={slots} />;
};

export default CategoryAnalysis;
